import type { BrandingType } from '@queries/fetchBrandings';

export const pickValidBrandingTemplates = (brandings: BrandingType[]) =>
  brandings.filter((b: BrandingType) => b.status === 'PUBLISHED');
